import axios from 'axios'
import { Notify } from 'vant';
 

 

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20 * 1000000
})

service.interceptors.request.use(
  config => {
    if (localStorage.getItem("userInfo")) {
      config.headers['Token'] = JSON.parse(localStorage.getItem("userInfo")).token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    const errMsg = res.message || res.msg || '请求失败'
    if (!res.success) {
      if(errMsg == "微信登录失效，请重新登录"||errMsg.indexOf("SecurityToken")!=-1||res.code === -2 || res.message == "登录已过期,请重新登录"){
        localStorage.clear();
        Notify({ type: 'warning', message: "您的登录状态已经失效，请重新登录" });
      }
      return Promise.reject(new Error(errMsg))
    } else {
      return res
    }
  },
  error => {
    // console.log('reject', { error })
    let errMsg = error.message || error.msg || '请求失败'
    if (error.response && error.response.data) {
      errMsg = error.response.data.msg
    }
    Notify({ type: 'danger', message: errMsg });
    return Promise.reject(error)
  }
)

export default service
